const isClip = false;
export default isClip;
